<template>
  <div class="table-page" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="cnt-header">
      <div class="top-btn">
        <el-button-group>
          <el-button type="primary" @click="addSuppliersBtn">添加供应商</el-button>
        </el-button-group>
      </div>

      <div class="search-input">
        <el-input
          style="width: 405px"
          :clearable="true"
          placeholder="输入(名称/服务类型/税号/地址/电话/开户行)检索"
          class="input-with-select"
          v-model="query"
          @keyup.enter.native="startQuery"
          @clear="clearInputVal"
        >
          <el-button slot="append" icon="el-icon-search" @click="startQuery"></el-button>
        </el-input>

        <el-button-group style="margin-left: 55px">
          <el-button
            type="primary"
            @click="uploaderBtn"
            round
            size="small"
            icon="el-icon-upload2"
            >导入</el-button
          >
          <el-button
            type="primary"
            round
            size="small"
            icon="el-icon-download"
            @click="filesExport('suppliers')"
            >导出</el-button
          >
        </el-button-group>
      </div>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="supplier_name" label="供应商名称"> </el-table-column>
      <el-table-column
        prop="service_type"
        label="服务类型"
      >
      </el-table-column>
      <el-table-column prop="tax_num" label="税号"> </el-table-column>
      <el-table-column prop="address" label="地址"> </el-table-column>
      <el-table-column prop="phone" label="电话"> </el-table-column>
      <el-table-column prop="bank" label="开户行"> </el-table-column>
      <el-table-column prop="bank_acount" label="开户行账号"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="updateSuppliersBtn(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            style="color: #f56c6c"
            @click="delSuppliers(scope.row.supplier_id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 25px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="form.supplier_id == null ? '新建供应商' : '修改供应商'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <div style="margin: 0 15px 0 35px">
        <el-form ref="form" :model="form" label-width="130px" :rules="rules">
          <div class="form-item-line">
            <el-form-item label="供应商名称" prop="supplier_name" class="left">
              <el-input v-model="form.supplier_name"></el-input>
            </el-form-item>
            <el-form-item label="服务类型" class="left">
              <el-select
                v-model="form.service_type"
                @focus="loadCargosOptions()"
                filterable
                placeholder="请选择服务类别"
              >
                <el-option
                  v-for="item in serviceTypeOpts"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item-line">
            <el-form-item label="账期" prop="pay_days" class="left">
              <el-input-number
                :controls="false"
                :min="0"
                v-model="form.pay_days"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="税号" prop="tax_num" class="left">
              <el-input v-model="form.tax_num"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="地址" prop="address" class="left">
              <el-input v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone" class="left">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="开户行" prop="bank" class="left">
              <el-input v-model="form.bank"></el-input>
            </el-form-item>
            <el-form-item label="开户行账号" prop="bank_acount" class="left">
              <el-input v-model="form.bank_acount"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="负责人" prop="principal" class="left">
              <el-input v-model="form.principal"></el-input>
            </el-form-item>
            <el-form-item label="负责人电话" prop="principal_call" class="left">
              <el-input v-model="form.principal_call"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="个人开户行" prop="personal_bank" class="left">
              <el-input v-model="form.personal_bank"></el-input>
            </el-form-item>
            <el-form-item label="个人开户行账号" prop="personal_account" class="left">
              <el-input v-model="form.personal_account"></el-input>
            </el-form-item>
          </div>

          <div class="form-item-line">
            <el-form-item label="供应商描述" prop="supplier_desc" class="left">
              <el-input v-model="form.supplier_desc" type="textarea"></el-input>
            </el-form-item>
          </div>

          <el-form-item>
            <el-button
              type="primary"
              @click="createSuppliers"
              v-if="form.supplier_id == null"
              >立即创建</el-button
            >
            <el-button type="primary" @click="updateSuppliers" v-else>立即修改</el-button>
            <el-button @click="dialogFormVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 文件上传表单 -->
    <el-dialog
      element-loading-text="Loading"
      element-loading-spinner="el-icon-loading"
      title="导入供应商"
      :visible.sync="dialogFileFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="host + '/api/suppliers/uploader'"
          :http-request="uploadFiles"
          name="fname"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="1"
          :auto-upload="false"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :on-change="handleChange"
          :data="uploadArgs"
          :on-success="handleSuccess"
        >
          <el-button size="small" type="primary" :disabled="fileLength > 0"
            >上传文件</el-button
          >
        </el-upload>
        <ul class="custom-dic-explanation">
          <li>文件扩展名要为xlsx或xls, 不超过10MB，编码仅支持UTF-8</li>
          <span class="custom-dic-template-download"
            ><a href="/files/文件导入模板.7z" class="custom-dic-demo-link"
              >参考demo下载</a
            ></span
          >
        </ul>
        <el-checkbox v-model="uploadArgs.is_cover" style="margin-top: 25px"
          >覆盖导入</el-checkbox
        >
        <font class="custom-dic-config"> （当前供应商中的值将被清空） </font>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose('cancel')">取 消</el-button>
        <el-button
          type="primary"
          @click="handleDialogClose('confirm')"
          :disabled="fileLength <= 0"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: [],
      fullscreenLoading: false,
      serviceTypeOpts: [],
      uploadArgs: {
        is_cover: false,
      },
      fileLength: 0,
      fileList: [],
      dialogFileFormVisible: false,
      form: {
        supplier_id: null,
        service_type: "",
        pay_days: 0,
        supplier_name: "",
        tax_num: "",
        address: "",
        phone: "",
        bank: "",
        bank_acount: "",
        principal: "",
        principal_call: "",
        personal_bank: "",
        personal_account: "",
        supplier_desc: "",
      },
      options: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      userInfo: {
        is_admin: false,
        user_id: null,
        username: "",
      },
      dialogFormVisible: false,
      rules: {
        supplier_name: [{ required: true, message: "请输入供应商名称", trigger: "blur" }],
        pay_days: [{ required: true, message: "请输入账期", trigger: "blur" }],
      },
      query: null,
    };
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    startQuery() {
      let that = this;
      that.currentPage = 1;
      if (that.query) {
        if (!that.query.trim()) {
          that.query = null;
        }
      }
      that.loadSuppliers(that.currentPage, that.pageSize);
    },
    clearInputVal() {
      let that = this;
      that.loadSuppliers(that.currentPage, that.pageSize);
    },
    filesExport(fileType) {
      let that = this;
      that.fullscreenLoading = true;
      that.$axios
        .get(that.host + "/api/files/exporter?file_type=" + fileType, {
          responseType: "blob",
          headers: { "Cache-Control": "no-cache" },
        })
        .then((res) => {
          let blob = new Blob([res.data]);
          let link = document.createElement("a");
          link.download = fileType + ".xlsx";
          link.href = URL.createObjectURL(blob);
          link.click();
          URL.revokeObjectURL(link.href);
          that.fullscreenLoading = false;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
          that.fullscreenLoading = false;
        });
    },
    handleRemove(file, fileList) {
      let that = this;
      that.fileLength = 0;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleChange(file, fileList) {
      let that = this;
      if (!file.name.endsWith("xlsx") && !file.name.endsWith("xls")) {
        that.$message.error("文件格式有误！");
        that.$refs.upload.clearFiles();
        that.fileLength = 0;
        that.uploadArgs.is_cover = false;
        return;
      }
      if (file.size / 1024 / 1024 > 10) {
        that.$message.error("文件大小超过10M有误！");
        that.$refs.upload.clearFiles();
        that.fileLength = 0;
        that.uploadArgs.is_cover = false;
        return;
      }
      that.fileLength = fileList.length;
    },
    uploadFiles(params) {
      let that = this;
      let fileObj = params.file;
      let action = params.action;
      let form = new FormData();
      that.fullscreenLoading = true;
      // 文件对象
      form.append("fname", fileObj);
      form.append("is_cover", that.uploadArgs.is_cover);
      that.$axios
        .post(action, form, { headers: { "Content-Type": "multipart/form-data" } })
        .then((res) => {
          that.handleSuccess(res.data);
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
          that.fullscreenLoading = false;
        });
    },
    handleSuccess(res, file, fileList) {
      let that = this;
      that.$refs.upload.clearFiles();
      that.dialogFileFormVisible = false;
      that.fileLength = 0;
      that.uploadArgs.is_cover = false;
      that.loadSuppliers(that.currentPage, that.pageSize);
      that.fullscreenLoading = false;
      that.$message.success("导入成功");
    },
    handleDialogClose(action) {
      let that = this;
      if (action == "cancel") {
        // 处理取消弹出框
        if (that.fileLength > 0) {
          that
            .$confirm("文件尚未上传，确认关闭？")
            .then((_) => {
              that.$refs.upload.clearFiles();
              that.dialogFileFormVisible = false;
              that.fileLength = 0;
              that.uploadArgs.is_cover = false;
            })
            .catch((_) => {});
        } else {
          that.dialogFileFormVisible = false;
          that.uploadArgs.is_cover = false;
        }
      } else if (action == "confirm") {
        // 处理确认弹出框
        that.loading = true;
        that.$refs.upload.submit();
        // that.dialogFormVisible = false;
      } else {
        that.$message.error("未知的动作！");
      }
    },
    uploaderBtn() {
      let that = this;
      that.dialogFileFormVisible = true;
    },
    handleSizeChange(pageSize) {
      let that = this;
      that.pageSize = pageSize;
      that.loadSuppliers(that.currentPage, pageSize);
    },
    handleCurrentChange(currentPage) {
      let that = this;
      that.currentPage = currentPage;
      that.loadSuppliers(that.currentPage, that.pageSize);
    },
    updateSuppliers() {
      let that = this;
      that.$axios
        .put(that.host + "/api/suppliers", that.form)
        .then((res) => {
          that.$message.success("修改成功");
          that.dialogFormVisible = false;
          that.loadSuppliers(that.currentPage, that.pageSize);
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    updateSuppliersBtn(data) {
      let that = this;
      that.form = data;
      that.dialogFormVisible = true;
    },
    loadCargosOptions(serviceType) {
      let that = this;
      return new Promise((resolve, reject) => {
        if (!serviceType) {
          that.$axios
            .get(that.host + "/api/cargos/options")
            .then((res) => {
              that.serviceTypeOpts = res.data.results;
              resolve();
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
              reject;
            });
        } else {
          that.statementForm.service_code = "";
          that.statementForm.service_desc = "";
          that.statementForm.service_remark = "";
          that.serviceCodeIdx = null;
          that.$axios
            .get(that.host + "/api/cargos/options?service_type=" + serviceType)
            .then((res) => {
              that.serviceCodeOpts = res.data.results;
              resolve();
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
              reject;
            });
        }
      });
    },
    delSuppliers(supplierID) {
      let that = this;
      this.$confirm("此操作将永久删除该供应商信息, 是否继续?", "删除供应商", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          that.$axios
            .delete(that.host + "/api/suppliers", {
              data: { supplier_id: supplierID },
            })
            .then((res) => {
              that.$message.success("删除供应商信息成功");
              that.currentPage = 1;
              that.loadSuppliers(that.currentPage, that.pageSize);
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addSuppliersBtn() {
      let that = this;
      that.dialogFormVisible = true;
      that.form = {
        supplier_id: null,
        supplier_name: "",
        supplier_desc: "",
      };
    },
    loadSuppliers(page, pageSize) {
      let that = this;
      let reqUrl = that.host + "/api/suppliers?page=" + page + "&page_size=" + pageSize;
      if (that.query) {
        reqUrl += "&query=" + that.query;
      }
      that.$axios
        .get(reqUrl)
        .then((res) => {
          let results = res.data.results;
          let filters = [];
          that.tableData = results.suppliers;
          for (let i = 0; i < that.tableData.length; i++) {
            filters.push({
              text: that.tableData[i].service_type,
              value: that.tableData[i].service_type,
            });
          }
          that.filters = filters;
          that.total = results.total_count;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    loadSuppliersOptions() {
      let that = this;
      that.$axios
        .get(that.host + "/api/suppliers/options")
        .then((res) => {
          that.options = res.data.results;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    createSuppliers() {
      let that = this;
      that.$refs["form"].validate((valid) => {
        if (valid) {
          that.$axios
            .post(that.host + "/api/suppliers", that.form)
            .then((res) => {
              that.$message.success("创建成功");
              that.dialogFormVisible = false;
              that.loadSuppliers(that.currentPage, that.pageSize);
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        } else {
          that.$message.warning("参数验证失败");
          return false;
        }
      });
    },
  },
  mounted() {
    let that = this;
    that.loadSuppliers(that.currentPage, that.pageSize);
  },
};
</script>

<style>
.filter-label {
  font-size: 14px;
  color: #e6a23c;
}
.cnt-header {
  position: relative;
  margin-bottom: 25px;
  line-height: 34px;
}
.filter-top {
  margin-right: 25px;
  display: inline-block;
}
.cnt-header .top-btn {
  display: inline-block;
}
.cnt-header .search-input {
  float: right;
}
.form-item-line {
  display: inline-block;
}
.form-item-line .left {
  float: left;
}
.table-page {
  padding: 0 30px 0 30px;
}
</style>
